import { List, Paper } from "@material-ui/core";
import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ItemsState } from "../../redux/state";
import { useFieldLookups } from "@ofqual/portal-core/core/hooks";
import { cachingAoService } from "../../services";
import { EventNotificationItem } from "./EventNotificationItem";
import { EventNotification } from "../../domain/EventNotification";

const SEARCH_STATE_KEY = "search";

export const ItemsList: React.FC<{ state: ItemsState }> = ({ state }) => {
  const { response } = state;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, { [SEARCH_STATE_KEY]: search });

  const orgIdsPresent = useMemo(
    () => response.data
      .filter(x => !!x.orgId)
      .map((item: EventNotification) => item.orgId as number).flat(),
    [response]
  );

  const orgLookups = useFieldLookups(cachingAoService, orgIdsPresent);

  return orgLookups ? (
    <Paper>
      <List disablePadding data-test="inbox-list">
        {response.data.map((item, index) => (
          <EventNotificationItem
            item={item}
            orgLookups={orgLookups!}
            navigate={navigate}
          />
        ))}
      </List>
    </Paper>
  ) : null;
};
